module.exports = __webpack_public_path__ + "static/corona-landing.6941c5d1.png";